// angular import
import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { GenericResourceService } from '@mri/app/resources';
import { interval, mergeMap, of, Subject, Subscription, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@mri/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private _sub = new Subscription();
  private _ping$ = new Subject()

  // public props
  isSpinnerVisible = true;
  isDisconnect = false;

  // constructor
  constructor(
    private _resourceSrv: GenericResourceService,
    private router: Router
  ) {

    this._sub.add(
      interval(10000)
        .pipe(tap(() => this._ping$.next(true)))
        .subscribe()
    );

    this._sub.add(this._ping$
      .pipe(
        mergeMap(() => this._pingToServer())
      )
      .subscribe());
  }

  ngOnInit() {
    // Use ngOnInit instead of ngAfterViewInit

    this._ping$.next(true);

    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          setTimeout(() => {
            this.isSpinnerVisible = true;
          });
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          setTimeout(() => {
            this.isSpinnerVisible = false;
          });
        }
      },
      () => {
        setTimeout(() => {
          this.isSpinnerVisible = false;
        });
      }
    );

  }

  private _pingToServer(){
    return this._resourceSrv.get(`${environment.apiUrl}/ping`)
      .pipe(

        tap(() => this.isDisconnect && location.reload()),

        catchError(e => of(this.isDisconnect = true))
      );
  }





}
